<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-two-thirds has-text-justified">
          <h1 class="title">Sponsors</h1>
          <p class="content">
            <strong
              >You are part of a
              <span class="has-text-primary">cosplay related organization</span> and want
              to have a great visibility on Costuto?</strong
            ><br />
            We offer solutions for your needs by providing Cosplayers an opportunity to
            <strong>discover your products</strong>, learn
            <strong>how they can be handled</strong> and get a
            <strong>feedback from the community</strong> on how they have experienced your
            service.<br />
            If you are interested and want to have more infomations on the alternatives we
            propose, don't hesitate to reach us through the form below or at
            <span class="has-text-primary">sponsor@costuto.com</span>.
          </p>

          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <ValidationProvider
              slim
              rules="required"
              name="Name"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="Name"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-input v-model="contact.name" icon="account-circle"></b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              slim
              rules="required"
              name="Name"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="Organization"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-input v-model="contact.name" icon="cart"></b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              slim
              rules="required|email"
              name="Email"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="Email"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="[errors[0], 'We will answer you at this address']"
              >
                <b-input
                  v-model="contact.email"
                  placeholder="Email"
                  type="email"
                  icon="email"
                >
                </b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              slim
              rules="required"
              name="Message"
              v-slot="{ errors, valid }"
            >
              <b-field
                label="Message"
                :type="{ 'is-danger': errors[0], 'is-success': valid }"
                :message="errors"
              >
                <b-input
                  v-model="contact.message"
                  maxlength="200"
                  type="textarea"
                ></b-input>
              </b-field>
            </ValidationProvider>

            <b-button @click="handleSubmit(sendMessage)" type="is-primary">
              <b-icon icon="send" size="is-small"></b-icon>
              <span>Send</span>
            </b-button>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import _ from 'lodash'

export default {
  mixins: [notificationMixin],
  data () {
    return {
      contact: {
        name: null,
        email: null,
        message: null
      },
      isLoading: false
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  methods: {
    sendMessage () {
      this.isLoading = true
      this.debouncedSending()
    }
  },
  created () {
    let self = this
    this.debouncedSending = _.debounce(() => {
      self.$store
        .dispatch('contacts/create', self.contact)
        .then((_) => {
          self.emailSent()
          self.isLoading = false
        })
        .catch((_) => {
          console.log('error')
          self.isLoading = false
        })
    }, 3000)
  }
}
</script>

<style lang="css" scoped></style>
